/**
 * Persistance locale de la DERNIÈRE transcription dictée, par cible (exercice ×
 * bloc × outil). Permet de rouvrir une dictée et de retrouver le texte —
 * visible et éditable — pour re-corriger sans tout redicter.
 *
 * Stockage localStorage (texte uniquement ; l'audio n'est jamais conservé).
 */

const PREFIX = 'jeraisonne.dictation.transcript:';

/** Clé stable pour une transcription : exercice × bloc × outil de dictée. */
export function transcriptKey(
  exerciseId: string,
  blockId: string,
  tool: 'answer' | 'edit' | 'figure',
): string {
  return `${PREFIX}${exerciseId}:${blockId}:${tool}`;
}

/** Lit la transcription mémorisée (chaîne vide si aucune). */
export function getSavedTranscript(key: string): string {
  try {
    return typeof localStorage !== 'undefined' ? (localStorage.getItem(key) ?? '') : '';
  } catch {
    return '';
  }
}

/** Enregistre (ou efface si vide) la transcription. */
export function saveTranscript(key: string, text: string): void {
  try {
    if (typeof localStorage === 'undefined') return;
    if (text.trim()) localStorage.setItem(key, text);
    else localStorage.removeItem(key);
  } catch {
    /* ignore (mode privé / quota) */
  }
}
